import {
  SHOW_PUBLIC_RECORDING_MAX_SECONDS,
} from '@fetmode/types';

export function captureVideoJpeg(video: HTMLVideoElement): string | null {
  if (video.videoWidth < 2 || video.videoHeight < 2) {
    return null;
  }
  const canvas = document.createElement('canvas');
  const width = Math.min(640, video.videoWidth);
  const height = Math.max(1, Math.round((video.videoHeight / video.videoWidth) * width));
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext('2d');
  if (!context) {
    return null;
  }
  context.drawImage(video, 0, 0, width, height);
  try {
    return canvas.toDataURL('image/jpeg', 0.72);
  } catch {
    return null;
  }
}

export function pickRecorderMimeType(): string | null {
  if (typeof MediaRecorder === 'undefined') {
    return null;
  }
  const candidates = ['video/webm;codecs=vp8,opus', 'video/webm;codecs=vp9,opus', 'video/webm'];
  for (const type of candidates) {
    if (MediaRecorder.isTypeSupported(type)) {
      return type;
    }
  }
  return null;
}

export async function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === 'string') {
        resolve(reader.result);
        return;
      }
      reject(new Error('read-failed'));
    };
    reader.onerror = () => {
      reject(new Error('read-failed'));
    };
    reader.readAsDataURL(blob);
  });
}

export const RECORDING_MAX_MS = SHOW_PUBLIC_RECORDING_MAX_SECONDS * 1000;
